import Config from 'scoreboard/components/bootslide/bootslide-menu'
import configBackground from '../wob-background-menu'
import fontSizeMenu from '../font-size-menu'
import MultipleChoiceOption from '../multiple-choice-option'
import WidgetConfigMenu from '../widget-config-menu'

var TextDirectionOption = MultipleChoiceOption.extend({
	property: 'labelDirection',
	defaultValue: 'horizontal',
	choices: [{
		label: 'horizontal',
		icons: ['text']
	}, {
		label: 'vertical',
		icons: ['text-direction-vertical']
	}]
})

var PerspectiveConfig = WidgetConfigMenu.extend({
	initialize: function (opt) {
		this.canvas = opt.canvas
		Config.prototype.initialize.apply(this, arguments)
	},

	typeSpecificTargets: function (hasTemplate) {
		let target = []

		target.push(configBackground(this.model.properties))
		target.push(fontSizeMenu(this.model.properties))

		target.push({
			type: 'icons',
			// Note: no need for i18n, not actually displayed, just used for class
			label: 'direction',
			contentView: TextDirectionOption
		})

		return target
	}
})

export default PerspectiveConfig

PerspectiveConfig.__filename__ = 'dashboards/widgets/perspective/perspective-config.js'
